import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import SpreadPartial from '../spread-partial';

class Component extends BaseComponent {
    render({ positions }) {
        return (
            <analysis-spread>
                <SpreadPartial positions={positions.slice(0, 5).map((p, i) => ({...p, card_index: i}))} />
                <SpreadPartial positions={positions.slice(5, 10).map((p, i) => ({...p, card_index: i + 5}))} />
            </analysis-spread>
        );
    }
}

const mapStateToProps = (state) => ({
    positions: state['tarot-reading'].positions,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/spreads/analysis.js